import React from "react";
import style from "./index.module.scss";
import { Table } from "antd";
import { ColumnProps, SortOrder } from "antd/es/table";
import moment from "moment";
import { CloudInfoListItem } from "API/navExperiment";

interface StuTableProps {
    data: CloudInfoListItem[];
    loading: boolean;
}

export default function StuTable({ data, loading }: StuTableProps) {
    const sortDirections: SortOrder[] = ["descend", "ascend"];

    const columns: ColumnProps<CloudInfoListItem>[] = [
        {
            title: "序号",
            key: "index",
            align: "center",
            width: 100,
            render: (text, item, index) => index + 1
        },
        {
            title: "开始时间",
            dataIndex: "BeginDay",
            align: "center",
            width: 200,
            sortDirections: sortDirections,
            sorter: (a: any, b: any) => {
                a = a.BeginDay === "" ? 0 : a.BeginDay;
                b = b.BeginDay === "" ? 0 : b.BeginDay;
                return moment(a).diff(b);
            },
            render: text => <div>{moment(text).format("MM-DD HH:mm")}</div>
        },
        {
            title: "结束时间",
            dataIndex: "EndDay",
            align: "center",
            width: 200,
            sortDirections: sortDirections,
            sorter: (a: any, b: any) => {
                a = a.EndDay === "" ? 0 : a.EndDay;
                b = b.EndDay === "" ? 0 : b.EndDay;
                return moment(a).diff(b);
            },
            render: text => <div>{moment(text).format("MM-DD HH:mm")}</div>
        },
        {
            title: "预约数量",
            dataIndex: "Used",
            align: "center"
        }
        // {
        //     title: '剩余数量',
        //     dataIndex: 'Total',
        //     align: "center",
        // },
    ];

    return (
        <div className={style.root}>
            <Table
                columns={columns}
                loading={loading}
                rowKey="OrderGuid"
                dataSource={data}
                pagination={false}
                scroll={{ y: 375 }}
            />
        </div>
    );
}
